"use client";

import type { EventPayload } from "@homeinstead/analytics";

import { track } from "@homeinstead/analytics";
import { scrollToTop } from "@homeinstead/shared";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { Button } from "../../Button/Button";

type TrackingEvent = {
  eventName: string;
  eventPayloadGenerator: (path: string, url: string) => EventPayload;
};

const ContinueButton = ({
  isEnabled,
  nextStep,
  trackingEvent,
}: {
  nextStep: () => void;
  isEnabled: boolean;
  trackingEvent: TrackingEvent;
}) => {
  const pagePath = usePathname();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // TODO stop suppressing this warning (don't replicate this!)
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsClient(true);
  }, []);

  const handleNextStep = () => {
    if (!isClient) {
      console.warn("Calling handleNextStep on the server");
      return;
    }

    track(
      trackingEvent.eventName,
      trackingEvent.eventPayloadGenerator(pagePath, window.location.href),
    );

    // Scroll to the top of the page on each new step
    scrollToTop();

    nextStep();
  };

  return (
    <Button
      className="mt-4 h-16 w-full rounded-full md:h-12"
      disabled={!isEnabled}
      onClick={handleNextStep}
      type="button"
    >
      Continue
    </Button>
  );
};

export default ContinueButton;
